export default __webpack_public_path__ + "static/media/product-21.b45c9748.jpg";